import { toast } from 'react-toastify';

const toastConfig = {
  autoClose: 8000,
  draggablePercent: 60
};

const success = message => toast.success(message, toastConfig);
const error = message => toast.error(message, toastConfig);
const info = message => toast.info(message, toastConfig);

export default {
  success,
  error,
  info
};



// WEBPACK FOOTER //
// ./src/shared/service/toast/ToastService.js